import {createContext} from 'react';
const EventContext = createContext();
export default EventContext;
